import ModalWifiEnabled from './ModalWifiEnabled';

export default ModalWifiEnabled;
